import { setSiteTheme } from 'config/theme';
import {
  BasicSchoolInformationResponse,
  BasicSchoolInformationRestControllerService,
} from 'generated';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  fetchHomePageStart,
  handleCollaboratorActive,
  handleEvaluatorActive,
} from 'redux/configuration/actions';
import { school_id } from 'utils/constants';
import { apiWrapper } from 'utils/http-client';
import { handleError } from 'utils/utils';

const useSchoolInfoGet = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState<boolean>(false);
  const [schoolInfo, setSchoolInfo] = useState<BasicSchoolInformationResponse | undefined>(
    undefined,
  );

  const fetchSchoolInfo = useCallback(async () => {
    setLoading(true);
    try {
      const data = await apiWrapper(() =>
        BasicSchoolInformationRestControllerService.getSchoolInformationUsingGet({
          schoolId: school_id,
        }),
      );

      const isEvaluatorActive = data?.basic_school_information_dto?.uses_evaluator_role;
      const isCollaboratorActive = data?.basic_school_information_dto?.uses_collaborator_role;
      dispatch(handleEvaluatorActive(isEvaluatorActive));
      dispatch(handleCollaboratorActive(isCollaboratorActive));
      dispatch(fetchHomePageStart());

      setSchoolInfo(data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      handleError(error);
    }
  }, [dispatch]);

  useEffect(() => {
    fetchSchoolInfo();
  }, [fetchSchoolInfo]);

  useEffect(() => {
    if (schoolInfo?.basic_school_information_dto?.color) {
      setSiteTheme(schoolInfo.basic_school_information_dto.color);
    }
  }, [schoolInfo]);

  return {
    loadingSchoolInfo: loading,
    fetchSchoolInfo,
    schoolInfo,
  };
};

export default useSchoolInfoGet;
